import { render, staticRenderFns } from "./ViewerMaster.vue?vue&type=template&id=478664fe"
import script from "./ViewerMaster.vue?vue&type=script&lang=js"
export * from "./ViewerMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports